export enum StateTypeEnumDTO {
    accept = 1,
    reject = 2,
    template = 3,
    seen = 4,
    active = 5,
}